import React from "react";

export const MedicalCareIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20.627"
      height="21.001"
      viewBox="0 0 20.627 21.001"
    >
      <path
        id="medical-care"
        d="M21.38,18.036v-3.3a2.75,2.75,0,1,0-5.5,0v3.5a2.748,2.748,0,0,1-5.475.345,2.22,2.22,0,0,0,.45-.165,1.819,1.819,0,0,0,1.03-1.685V14.805A5.928,5.928,0,0,0,14.92,13.09a6.785,6.785,0,0,0,1.665-3.26l.98-4.905a1.205,1.205,0,0,0-1.185-1.45H15.315a2,2,0,1,0,0,1H16.38a.212.212,0,0,1,.165.075.185.185,0,0,1,.04.17L15.6,9.625a5.826,5.826,0,0,1-1.42,2.78,5.069,5.069,0,0,1-3.745,1.565h-.5a5.192,5.192,0,0,1-3.275-1.145,5.538,5.538,0,0,1-1.92-3.2L3.764,4.72a.232.232,0,0,1,.04-.175.2.2,0,0,1,.16-.075h.99a2,2,0,1,0,0-1h-.99a1.2,1.2,0,0,0-.935.44,1.19,1.19,0,0,0-.245,1.005l.98,4.905a6.5,6.5,0,0,0,2.29,3.8,5.948,5.948,0,0,0,1.83,1.005v2.1a1.891,1.891,0,0,0,.915,1.61,2.109,2.109,0,0,0,.605.245,3.748,3.748,0,0,0,7.48-.355v-3.5a1.75,1.75,0,1,1,3.5,0v3.3a2.5,2.5,0,1,0,1,0Zm-8-13.05a1,1,0,1,1,1-1A1,1,0,0,1,13.379,4.985Zm-6.5-2a1,1,0,1,1-1,1A1,1,0,0,1,6.879,2.985Zm2,13.75V14.89a6.175,6.175,0,0,0,1.055.09h.5c.15,0,.3-.01.445-.02v1.775a.842.842,0,0,1-.46.78,1.12,1.12,0,0,1-1.1-.02.9.9,0,0,1-.44-.76Zm12,5.25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,20.88,21.986Z"
        transform="translate(-2.758 -1.97)"
        fill="#2e2e2e"
      />
    </svg>
  );
};
